
import { createStore } from 'vuex'


const store = createStore({
  state () {
    return {
      sideBarState:true,
      serverUrl:'http://120.55.95.207:9000',
      messageList:[],
    }
  },
  mutations: {
    /**
     * 设置侧边栏显示状态
     * @param state 
     * @param {boolean} sideBarState 侧边栏新状态 true显示 false隐藏
     */
    setSideBarState(state,sideBarState){
      state.sideBarState=sideBarState;
    },
    // /**          搁置 一般无这种需求
    //  * 获取服务器上的公开数据 此逻辑主要功能是为了后续的维护与拓展
    //  * @param  state 
    //  * @param  vue  传入一个有axios的vue实例 一般this就行
    //  */
    // getGlobalData(state,vue){
    //   vue.axios.get('/globalData').then((res)=>{
    //     state.Archies=res.data.data.Archies
    //   })
    // },

    messageAdd(state,payload){
      if(state.messageList.length>10){
        state.messageList.shift();
      }
      state.messageList.push(
        payload.text
      )
    }

  }
})
export default store